module.exports = __webpack_public_path__ + "img/通知.ade3d0d3.png";